import Vue from 'vue'
import Router from 'vue-router'
import presentation from '@/components/presentation/layout'
import common from '@/components/login/common'
import passchange from '@/components/login/passchange'
import qtyincrease from '@/components/qtychange/qtyincrease'
import qtyreduce from '@/components/qtychange/qtyreduce'
import received from '@/components/received/received'
import aggregate from '@/components/news/aggregate'
import edit from '@/components/edit/edit'
import printaspdf from '@/components/print/printaspdf'
import modifys from '@/components/batchmodifys/modifys'
import test from '@/components/utility/test.vue'
import exceltodb from '@/components/exceltodb/index'

Vue.use(Router)
let constRouter=[
  {path:'/test',
  component:test
},
  {
    path: '/',
    name: 'presentation',
    component: presentation
  },

  {
    path:"/login",
    name:"login",
    component:common
  },
  {
    path:"/edit",
    name:"edit",
    component:edit
  },
  {
    path:"/printaspdf",
    name:"printaspdf",
    component:printaspdf
  },

  {
    path:"/modifys",
    name:"modifys",
    component:modifys
  },

  {
    path:"/qtyincrease",
    name:"qtyincrease",
    component:qtyincrease
  },
  {
    path:"/qtyreduce",
    name:"qtyreduce",
    component:qtyreduce
  },
  {
    path:"/received",
    name:"received",
    component:received
  },
  {
    path:"/aggregate",
    name:"aggregate",
    component:aggregate
  },
  {
    path:"/passchange",
    name:"passchange",
    component:passchange
  },
  // {
  //   path:"/rolesetting",
  //   name:"rolesetting",
  //   component:rolesetting
  // },
  {
    path:"/exceltodb",
    name:"exceltodb",
    component:exceltodb
  },


];
let router = new Router({
  routes: constRouter
})

const whiteList = ['/','/login']

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  let token = localStorage.getItem('USER_TOKEN')
  //let user = localStorage.getItem('USER')

  if (whiteList.indexOf(to.path) !== -1) {
    next()
  }
  else if (token) {
    next()
  }
  else{
   
    next("/login")
  }
})



export default router



// WEBPACK FOOTER //
// ./src/router/index.js